import React from 'react'
import { Modal } from '@entur/modal'
import { PrimaryButton, SecondaryButton } from '@entur/button'
import { space } from '@entur/tokens'
import { useLocation, useNavigate } from 'react-router-dom'
import { BannerAlertBox } from '@entur/alert'
import { FetchState } from '../../api-clients/api-types'
import { useApi } from '../../api-clients/client-hooks'
import { postRestoreEmployee } from '../../api-clients/eba-clients'
import { useEmployee } from '../../contexts/employee-context'
import { HistoryState } from '../../types'

type RestoreEmployeeModalProps = {
  open: boolean
  close: () => void
}

export const RestoreEmployeeModal: React.FC<RestoreEmployeeModalProps> = (props) => {
  const navigate = useNavigate()
  const loc = useLocation()
  const locState = loc.state as HistoryState | undefined

  const { employee } = useEmployee()
  const [response, post] = useApi(postRestoreEmployee, {
    successCallback: () => {
      props.close()
      navigate(`/ansatt/${employee.id}#gjenopprettet`, { state: locState })
    },
  })

  const restoreEmployee = React.useCallback(() => post({ id: employee.id }), [post, employee.id])

  return (
    <Modal
      data-cy="restore-employee-modal"
      size="medium"
      title="Åpne opp profil"
      open={props.open}
      onDismiss={props.close}
    >
      {response.status === FetchState.ERROR && (
        <BannerAlertBox
          variant="error"
          title="Kan ikke gjennopprette profilen"
          data-cy="restore-employee-banner-error"
          closable={false}
          style={{ marginBottom: '1em' }}
        >
          Det har skjedd en teknisk feil, ta kontakt med Entur support
        </BannerAlertBox>
      )}
      <p style={{ marginBottom: space.extraLarge2 }}>
        Er du sikker du vil åpne opp profilen til {employee.firstName} {employee.surname}? <br />
        Profilen er markert slettet fordi den ikke har hatt rettigheter de seneste årene. Når profilen er åpnet vil
        det være mulig å gi rettigheter.
      </p>
      <PrimaryButton
        data-cy="restore-employee-modal-primary-button"
        style={{ marginRight: space.medium }}
        onClick={restoreEmployee}
      >
        Åpne opp profil
      </PrimaryButton>
      <SecondaryButton data-cy="restore-employee-modal-secondary-button" onClick={props.close}>
        Avbryt
      </SecondaryButton>
    </Modal>
  )
}
